import {mapGetters, mapActions, mapState} from 'vuex';

import clubsModule from '@clubs/module/store/type'
import mixin from '@general/lib/mixin';

export default {
    computed: {
        ...mapState({
            profile: 'profile'
        }),
        ...mapGetters({
            membershipClubsRequests: clubsModule.getters.membershipClubsRequests
        }),
        membershipActionText(){
            let string = 'join'

            if (this.club.membership === 'host') {
                string = 'host'
            } else if (this.club.membership === 'member') {
                string = 'member'
            } else if (this.club.membership === 'requested') {
                string = 'pending'
            } else if (
                this.club.membership === 'removed'
                ||
                this.club.membership === 'rejected'
            ) {
                string = 'declined'
            } else if (this.club.membership === null) {
                string = 'join'
            }

            return this.trans(string)
        },
        membershipActionBtnClass(){
            if (this.club.membership === 'member') {
                return 'btn'
            }
            if (this.club.membership === 'host') {
                return ['btn', 'bb-button-no_pointer']
            }
            return 'btn'
        },
        membershipActionDisabled(){
            return ['requested', 'rejected'].includes(this.club.membership)
        },
    },
    methods: {
        ...mapActions({
            reloadClub: clubsModule.actions.clubs.loadInfo,
            requirementsAlertShow: 'requirementsAlertShow',
            toggleEventLike:       clubsModule.actions.clubs.like,
            setClub:               clubsModule.actions.setClub,
            requestMembership:     clubsModule.actions.membership.request,
            showDialog:            'showDialog'
        }),
        createClub() {
            if(this.showJoinModalIfNeed()){
                return false;
            }
            if (!this.userIsPro && this.myClubs && this.myClubs.length >= window.FREE_CLUBS_LIMIT) {
                this.requirementsAlertShow('clubs')
            } else {
                console.log('createClub', { entityType: 'club' })
                if (this.isDesktop) {
                    this.openClubModal(null, 'club', 'create')
                } else {
                    this.$router.push({name: 'create-club'})
                }
            }
        },
        acceptAllMembers(club) {
            let payload = {
                eventId: club.id,
                clubId:  club.id,
                action: 'accept'
            }

            let acceptUsers = club.members.filter(member => member.status === 'requested')
            for (let i in acceptUsers) {
                this.requestMembership(
                    Object.assign(
                        {},
                        payload,
                        {userId: acceptUsers[i].id}
                    )
                )
            }

            mixin.methods.showSuccessNotification('Users successfully accepted')
            club.invitedMembers = []
        },
        editClub(clubId, type){
            console.log('editClub', { entityType: 'club', clubId })
            if (this.isDesktop) {
                this.openClubModal(clubId, 'club', 'edit')
            } else {
                this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:this.clubId,edit:1}).then(() => {
                    this.$router.push({
                        name: 'edit-club',
                        params: { clubId }
                    })
                })
            }
        },
        openClub(clubId, type) {
            console.log('openClub', { entityType: 'club', clubId })
            if (this.isDesktop) {
                if (this.$route.name !== 'clubs') {
                    this.$router.push({name: 'clubs'})
                }
                this.openClubModal(clubId, 'club')
            } else {
                this.$router.push({
                    name: 'club',
                    params: { clubId }
                })
            }
        },
        async openClubModal(clubId, type, mode) {
            let response = null;
            //need to disable transition for members loading infinitive loadinng plugin
            await this.$store.commit(clubsModule.mutations.setTransitionEnabled, false);
            await this.$store.dispatch(clubsModule.actions.setClub, { visible: false });
            await this.$store.commit(clubsModule.mutations.setTransitionEnabled, true);
            if (mode !== 'create') {
                if (!!app.ClubInfoCancelSource) {
                    app.ClubInfoCancelSource.cancel()
                    app.ClubInfoCancelSource = null
                }
                response = await this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:clubId,edit:0})
            }
            if(response || mode === 'create'){
                let self = this;
                let payload = {
                    visible: true,
                    clubId,
                    mode: mode || 'view'
                }
                console.log('[openClubModal]', payload)

                self.$store.dispatch(
                    clubsModule.actions.setClub,
                    payload
                )
            }

        },
        closeClub() {
            this.$store.dispatch(clubsModule.actions.setClub, { visible: false })
        },
        closeBang() {
            this.$store.dispatch(clubsModule.actions.setClub, { visible: false })
        },
        async handleClubInvitation(type, data, callback)
        {
            return await axios.post('/api/handle-invitation/' + type, data).then(() => {
                callback();
            });
        },
        acceptClubInvitation(data, callback)
        {
            return this.handleClubInvitation('accept', data, callback);
        },
        declineClubInvitation(data, callback)
        {
            return this.handleClubInvitation('decline', data, callback);
        },

        async handleEventInvitation(type, data, callback)
        {
            return await axios.post('/api/handle-invitation/'+type, data).then(response => {
                //all is good, no need to do anything
                callback();
            }).catch((e) => {

            });
        },
        deleteEventInvitation(data)
        {
            return this.handleEventInvitation('delete', data);
        },
        resetClubsAround() {
            console.log('[Clubs] Reset')

            this.$store.commit(clubsModule.mutations.clubs.set, {
                loading:  false,
                invited:  [],
                accepted: [],
                my_clubs: [],
                discover: [],
                discover_has_more: false
            });
            this.$store.commit(clubsModule.mutations.resetPagination)

            app.lastClubsAroundRefresh = moment();

            //otherwise it would scroll to the bottom when you change filter
            $('#js-clubs-content').animate({scrollTop: 0}, 0);

            if (this.$refs.infiniteLoadingClubs) {
                this.$refs.infiniteLoadingClubs.stateChanger.reset()
            } else {
                console.log('No infiniteLoadingClubs ref found')
            }

            if(store.getters[clubsModule.getters.type] === 'my_clubs'){
                store.dispatch('signalClubsSeen')
            }
        },
        async loadClubs(infiniteScroll) {
            let datesCount = await this.$store.dispatch(clubsModule.actions.clubs.load)
            if(datesCount !== 'error'){
                infiniteScroll.loaded()
            }
            if (datesCount && datesCount !== 'error') {
                infiniteScroll.complete()
            }
        },
        updateMembership(payload){
            if(this.showJoinModalIfNeed()){
                return false;
            }
            let membershipStatus = this.club.membership || null
            console.log('[updateMembership]', {
                initialStatus: membershipStatus
            })

            let self = this
            switch (membershipStatus) {
                case null:
                case 'leaved':{
                    // Dialog - I want to take part. Send my application - YES / NO
                    // Your application has been sent
                    payload.action = 'request'
                    this.showDialog({
                        mode: 'confirm',
                        message: 'Send your application?',
                        callback: async () => {
                            await self.requestMembership(payload)
                            self.reloadClub({clubId: payload.clubId, edit : 0, dont_reset_members : true})
                            /*self.resetMembers();
                            if (self.$refs.infiniteLoadingClubMembers) {
                                self.$refs.infiniteLoadingClubMembers.stateChanger.reset();
                            }*/
                        }
                    })

                    break
                }
                case 'host':{
                    // You are the host
                    return
                }
                case 'member':{
                    // I am a member already - LEAVE / STAY
                    // Dialog - Leave now? - NO / YES
                    // You have left this event
                    this.showDialog({
                        mode: 'confirm',
                        message: `Leave this club?`,
                        callback: async () => {
                            payload.action = 'leave'
                            await self.requestMembership(payload)

                            this.closeBang();
                            setTimeout(function () {
                                app.$emit('reload-events')
                            }, 1500)
                        }
                    })
                    break
                }
                case 'requested':{
                    // Your application has been sent already
                    return
                }
                default:{
                    console.log('[updateMembership] Out of scope. Aborted.')
                    return
                }
            }
        },
        updateUserMembership(user, action, club) {
            let self = this
            let payload = {
                eventId: this.clubIdComputed,
                clubId: this.clubIdComputed,
                userId: user.id,
                action
            }

            if (action === 'accept') {
                this.showDialog({
                    mode: 'confirm-or-view-profile',
                    user:  user,
                    club: club,
                    message: `Accept ${user.name} to the club?`,
                    callback: async () => {
                        await self.requestMembership(payload)
                        self.resetMembers();
                        if (self.$refs.infiniteLoadingClubMembers) {
                            self.$refs.infiniteLoadingClubMembers.stateChanger.reset();
                        }
                    },
                    callbackNegative: async () => {
                        payload.action = 'reject'
                        await self.requestMembership(payload)
                        self.resetMembers();
                        if (self.$refs.infiniteLoadingClubMembers) {
                            self.$refs.infiniteLoadingClubMembers.stateChanger.reset();
                        }
                    },
                })

            } else if (action === 'remove') {
                this.showDialog({
                    mode: 'confirm',
                    message: `Remove ${user.name} from the club?`,
                    callback: async () => {
                        await self.requestMembership(payload)
                        self.resetMembers();
                        if (self.$refs.infiniteLoadingClubMembers) {
                            self.$refs.infiniteLoadingClubMembers.stateChanger.reset();
                        }
                    }
                })
            }
        }
    }
}
